import styled from '@emotion/styled';
import { Button } from 'antd';

export const SButton = styled(Button)`
  font-size: 18px;
  width: 200px;
  height: 50px;
  margin: 60px 0;
  border-radius: 8px;
  direction: ltr;
  .ant-btn-loading-icon {
    margin-right: 12px;
  }
`;
